import Vue from 'vue'
import App from '@/App.vue'
import {
	store
} from '@/store/store'
import '@/filters/filters'
import router from '@/router'
import '@/registerServiceWorker'
import {
	loading
} from '@/directives/directives'
import VueResource from 'vue-resource'
import VeeValidate, {
	Validator
} from 'vee-validate'
import VueCookies from 'vue-cookies'
import dict from '@/assets/js/dict'
import Toasted from 'vue-toasted'

import Autocomplete from 'v-autocomplete'
import vSelect from 'vue-select'
import 'v-autocomplete/dist/v-autocomplete.css'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueAgile from 'vue-agile'
import VueLazyload from 'vue-lazyload'
import VueSocialSharing from 'vue-social-sharing'

import {
	Tabs,
	Tab
} from 'vue-tabs-component'

// eslint-disable-next-line no-unused-vars
import jquery from 'jquery'

// import '@/assets/js/main'
import 'bootstrap'

import 'owl.carousel'
// eslint-disable-next-line no-unused-vars
import leaflet from 'leaflet'
import { unomiApis } from './services/ApiServices/unomiApis'

Vue.config.productionTip = false

Vue.directive('loading', loading)
Vue.use(VuejsDialog)
Vue.use(Autocomplete)
Vue.component('v-select', vSelect)
Vue.use(VueAgile)
Vue.use(VueResource)
Vue.use(VueCookies)
Vue.use(Toasted, {
	position: 'bottom-center',
	duration: 3000,
	iconPack: 'fontawesome',
	icon: 'check-circle',
	singleton: true
})

Validator.extend('confirmation', {
	getMessage: field => `${field} does not match`,
	validate (value, args) {
		const field = document.querySelector(`${args[0]}`)
		return !!(field && String(value) === field.value)
	}
})
Validator.localize('en', dict)
Vue.use(VeeValidate, {
	events: 'change|blur',
	fieldsBagName: 'formFields'
})

Vue.component('tabs', Tabs)
Vue.component('tab', Tab)
Vue.use(VueSocialSharing)

/* http Request response interceptor */
Vue.http.interceptors.push((request, next) => {
	next((response) => {
		if ((response.status === 401) &&
      !(response.url.includes('verifyOtp') ||
        response.url.includes('editpassword'))) {
			store.dispatch('user/clearUserData')
			store.dispatch('wishlist/emptyWishlist')
			// store.dispatch('cart/emptyCart');
			if (router.currentRoute.matched.some(record => record.meta.requiresAuth)) {
				router.push({
					name: 'Home'
				})
			}
		}
	})
})
Vue.http.interceptors.push((request, next) => {
	next((response) => {
		if (response.status === 401) {
			store.dispatch('vendor/setVendorAuthenticated', false)
			if (router.currentRoute.matched.some(record => record.meta.requiresVendorAuth)) {
				router.push('/vendorLogin')
			}
		}
	})
})

// Analytics interceptor
Vue.http.interceptors.push(function (request, next) {
	const viewConfig = [
		{ key: 'grocery', value: 'groceryViewEvent' },
		{ key: 'men', value: 'menFashionViewEvent' },
		{ key: 'women', value: 'womenFashionViewEvent' }
	]

	// to fix exclude order in analytics add if(data1) in second for loop
	if (request.url !== '/api/v2/analytics/create' && !request.url.includes('order')) {
		let itemTypeId = 'ECOM_EVENT_TYPE'
		for (let viewData of viewConfig) {
			if ((request.body !== null && request.body !== undefined) || (request.url !== null && request.url !== undefined)) {
				let resData = []
				if (request.body !== undefined && request.body !== null) {
					resData = Object.values(request.body)
				}
				for (let data of resData) {
					const data1 = JSON.stringify(data)
					if ((data1.includes(viewData.key) || request.url.includes(viewData.key))) {
						itemTypeId = viewData.value
						break
					}
				}
			}
		}
		const eventData = {
			eventType: 'ECOM_SERVICE',
			scope: 'ECOMMERCE',
			target: {
				itemId: itemTypeId,
				reffedUrl: request.url
			}
		}
		unomiApis.postEvents(eventData)
		next()
	}
})

Vue.http.headers.common['Unomi-Session'] = Vue.cookies.get('unomi-session-id')

Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: './assets/loader/placeholder-images.png',
	loading: './assets/loader/placeholder-images.png',
	attempt: 1
})

new Vue({
	store,
	router,
	beforeCreate () {
		this.$store.commit('initialiseStore')
	},
	render: h => h(App)
}).$mount('#app')
